(() => {
  'use strict';
  if (window.noiseWishlistCartBridge) return;
  window.noiseWishlistCartBridge = true;
  let refreshTimer;

  // Notify Me emits these after a successful cart mutation. Broadcast's drawer
  // listens to its own event instead. Merge the app's three notifications so
  // one addition refreshes the existing cart without adding merchandise again.
  function scheduleCartRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
      document.querySelectorAll('cart-items').forEach(cart => {
        if (cart.isCartPage && typeof cart.getCart === 'function') cart.getCart();
      });
    }, 120);
  }
  ['apps:product-added-to-cart', 'cart:refresh', 'cart:updated'].forEach(event => {
    document.addEventListener(event, scheduleCartRefresh);
  });
})();
